import products from './search-and-browse-products';

export default state => [products(state)];
